import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import QuestionDetailListCard from '../questionDetail/QuestionDetailListCard';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { numericPropertyType } from 'constants/propertyType';

const QuestionListItemComponent = ({
  question,
  questionTypes,
  index,
  collectionValidation,
  isReadOnly,
  onPropertyChanged,
  onAddNewQuestionDetailRow,
  onDetailPropertyChanged,
  onDeleteQuestionDetailRow
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Prompt when={question.changed && !isReadOnly} message={t('Questionnaire.LeavingWithoutSavingQuestion', { index: index + 1 })} />
      <Grid item container spacing={2}>
        <Grid item xs={12} sm={3}>
          <TextField
            isNumeric
            fullWidth
            value={question.orderNo}
            onChange={event => onPropertyChanged('orderNo', event, index)}
            label={t('Questionnaire.Question.OrderNo')}
            decimalScale={0}
            error={!isValid(collectionValidation[index].orderNo)}
            helperText={getErrors(collectionValidation[index].orderNo)}
            disabled={isReadOnly}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            value={question.questionCode || ''}
            onChange={event => onPropertyChanged('questionCode', event, index)}
            label={t('Questionnaire.Question.QuestionCode')}
            error={!isValid(collectionValidation[index].questionCode)}
            helperText={getErrors(collectionValidation[index].questionCode)}
            disabled={isReadOnly}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            fullWidth
            value={question.questionTypeId}
            options={questionTypes}
            onChange={event => onPropertyChanged('questionTypeId', event, index)}
            simpleValue
            label={t('Questionnaire.Question.QuestionType')}
            error={!isValid(collectionValidation[index].questionTypeId)}
            helperText={getErrors(collectionValidation[index].questionTypeId)}
            disabled={isReadOnly}
          />
        </Grid>
        {question.questionTypeId === numericPropertyType && (
          <Grid item xs={12} sm={3}>
            <TextField
              isNumeric
              fullWidth
              value={question.numericPrecision || ''}
              onChange={event => onPropertyChanged('numericPrecision', event, index)}
              label={t('Questionnaire.Question.NumericPrecision')}
              decimalScale={0}
              error={!isValid(collectionValidation[index].numericPrecision)}
              helperText={getErrors(collectionValidation[index].numericPrecision)}
              disabled={isReadOnly}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={9}>
          <TextField
            fullWidth
            value={question.questionName || ''}
            onChange={event => onPropertyChanged('questionName', event, index)}
            label={t('Questionnaire.Question.QuestionName')}
            error={!isValid(collectionValidation[index].questionName)}
            helperText={getErrors(collectionValidation[index].questionName)}
            disabled={isReadOnly}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={question.mandatory || false}
                onChange={event => onPropertyChanged('mandatory', event.target.checked, index)}
                color='primary'
                disabled={isReadOnly}
              />
            }
            label={t('Questionnaire.Question.Mandatory')}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <QuestionDetailListCard
            questionDetails={question.questionDetails}
            questionId={question.questionId}
            questionIndex={index}
            loading={false}
            validation={collectionValidation[index].questionDetails}
            isReadOnly={isReadOnly}
            onAddNewQuestionDetailRow={onAddNewQuestionDetailRow}
            onDetailPropertyChanged={onDetailPropertyChanged}
            onDeleteQuestionDetailRow={onDeleteQuestionDetailRow}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            value={question.formula || ''}
            onChange={event => onPropertyChanged('formula', event, index)}
            label={t('Questionnaire.Question.Formula')}
            disabled={isReadOnly}
          />
        </Grid>
      </Grid>
    </>
  );
};

QuestionListItemComponent.propTypes = {
  question: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  questionTypes: PropTypes.array,
  collectionValidation: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  onPropertyChanged: PropTypes.object.isRequired,
  onAddNewQuestionDetailRow: PropTypes.object.isRequired,
  onDetailPropertyChanged: PropTypes.object.isRequired,
  onDeleteQuestionDetailRow: PropTypes.func.isRequired
};
export default QuestionListItemComponent;
